import React, {useCallback, useState} from 'react'

import {IconButton} from '../../../button'
import {Grid} from '../../../grid'
import {MinusIcon, PlusIcon} from '../../../icons'
import {MapListener} from '../../components'
import {DEFAULT_ZOOM, DEFAULT_ZOOM_DURATION} from '../../consts'
import {MapEvents, MapLocationRequest} from '../../types'
import {classes} from './MapZoomCustomControl.classes'

type Props = {
  duration?: number
  setLocation: (location: MapLocationRequest) => void
  zoomRange?: [min: number, max: number]
}

function MapZoomCustomControl({duration = DEFAULT_ZOOM_DURATION, setLocation, zoomRange = [0, 21]}: Props) {
  const [currentZoom, setCurrentZoom] = useState<number>(DEFAULT_ZOOM)

  const onUpdate: MapEvents['onUpdate'] = useCallback(updateObject => {
    setCurrentZoom(updateObject.location.zoom)
  }, [])

  const changeZoom = useCallback(
    (delta: number) => {
      const newZoom = Math.min(Math.max(currentZoom + delta, zoomRange[0]), zoomRange[1])
      setLocation({
        zoom: newZoom,
        duration: duration,
      })
    },
    [currentZoom, duration, setLocation],
  )

  const onZoomIn = useCallback(() => {
    changeZoom(1)
  }, [changeZoom])
  const onZoomOut = useCallback(() => {
    changeZoom(-1)
  }, [changeZoom])

  const isZoomInDisabled = currentZoom >= zoomRange[1]
  const isZoomOutDisabled = currentZoom <= zoomRange[0]

  return (
    <div className={classes.container}>
      <Grid className={classes.zoomControl} direction="column" container>
        <IconButton disabled={isZoomInDisabled} onPress={onZoomIn} shape="circle" variant="floating">
          <PlusIcon />
        </IconButton>
        <IconButton disabled={isZoomOutDisabled} onPress={onZoomOut} shape="circle" variant="floating">
          <MinusIcon />
        </IconButton>
        <MapListener onUpdate={onUpdate} />
      </Grid>
    </div>
  )
}

export default React.memo(MapZoomCustomControl)
